var map = {
	"./bkg.png": "687a",
	"./bkg_icon.png": "835f",
	"./btn_bg.png": "7180",
	"./cyber.png": "31f9",
	"./desktop_bkg.png": "51b4",
	"./fraud.png": "5e7f",
	"./fun_corner.png": "e0d2",
	"./fun_corner_icon.png": "c4b8",
	"./law.png": "15f4",
	"./madam_classroom.png": "df43",
	"./other_info.png": "2d17",
	"./physical_harm.png": "9b75",
	"./protect.png": "556e",
	"./sexual_violence.png": "d44f",
	"./smart_guard.png": "5e6f",
	"./smart_guard_icon.png": "2a9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebe9";